import { useEffect, useState } from "react";
import useApi from "./useApi";

// Imágenes administrables desde el panel admin (Personalizar).
// Arranca con los assets estáticos para no dejar el espacio en blanco
// mientras carga, y los reemplaza por los configurados cuando el backend
// responde; si la API falla, los estáticos quedan como fallback.
//
// - logo: para fondos oscuros (barra de menús).
// - logoClaro: para fondos blancos (login, registro, recuperar/restablecer
//   contraseña, pantallas de éxito/error). Si el admin no subió uno
//   específico, cae al logo general antes que al estático.
// - icono: el símbolo cuadrado de la marca, sin texto. Si el admin no subió
//   uno, cae al logo general antes que al estático.
// - home: imagen de fondo del login/registro (null si no hay configurada,
//   para que cada pantalla decida su propio fallback).
//
// Cada consumidor pasa sus propios respaldos estáticos: la landing usa sus
// PNG de marca y el resto de la app el SVG genérico.
const useLogos = (respaldos = {}) => {
  const { loadApi } = useApi();
  const [imagenes, setImagenes] = useState({
    logo: respaldos.logo || "/assets/logo.svg",
    logoClaro: respaldos.logoClaro || "/assets/logo.svg",
    icono: respaldos.icono || respaldos.logoClaro || "/assets/logo.svg",
    home: null,
  });

  useEffect(() => {
    loadApi("general/parametros", false, "get")
      .then(({ data }) => {
        setImagenes((previas) => ({
          logo: data.logo || previas.logo,
          logoClaro: data.logo_claro || data.logo || previas.logoClaro,
          icono: data.icono || data.logo || previas.icono,
          home: data.home || null,
        }));
      })
      .catch(() => {});
  }, []);

  return imagenes;
};

export default useLogos;
